import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ROUTES } from '../../consts';

const ProtectedRoute = ():JSX.Element => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to={ { pathname: ROUTES.LOGIN } } />;
};

export default ProtectedRoute;
